module.exports = __webpack_public_path__ + "img/buzz-01.b64741c0.png";